import { render, staticRenderFns } from "./Step2Desktop.vue?vue&type=template&id=05a2fd3a&scoped=true&"
import script from "./Step2Desktop.vue?vue&type=script&lang=js&"
export * from "./Step2Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Step2Desktop.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Step2Desktop.vue?vue&type=style&index=1&id=05a2fd3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a2fd3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a2fd3a')) {
      api.createRecord('05a2fd3a', component.options)
    } else {
      api.reload('05a2fd3a', component.options)
    }
    module.hot.accept("./Step2Desktop.vue?vue&type=template&id=05a2fd3a&scoped=true&", function () {
      api.rerender('05a2fd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Step2Desktop.vue"
export default component.exports